import Button from '../../../components/base/Button';

export default function ImpactSection() {
  const stats = [
    {
      number: "2,500+",
      label: "Active Members",
      description: "Pharmacists, veterinarians, and healthcare advocates"
    },
    {
      number: "150+",
      label: "Educational Programs",
      description: "Continuing education courses and workshops annually"
    },
    {
      number: "50+",
      label: "Research Projects",
      description: "Collaborative studies advancing One Health initiatives"
    },
    {
      number: "10",
      label: "Provincial Chapters",
      description: "Local representation across Canada"
    },
    {
      number: "25+",
      label: "Policy Initiatives",
      description: "Advocacy efforts improving healthcare legislation"
    },
    {
      number: "5,000+",
      label: "Patients Served",
      description: "Through integrated care programs and initiatives"
    }
  ];

  return (
    <section className="py-16 bg-blue-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Our Impact
          </h2>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Measuring our success through the positive changes we bring to healthcare communities across Canada.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">
                {stat.number}
              </div>
              <div className="text-xl font-semibold text-blue-100 mb-2">
                {stat.label}
              </div>
              <div className="text-blue-200 text-sm">
                {stat.description}
              </div>
            </div>
          ))}
        </div>
        
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 text-center">
          <h3 className="text-2xl font-bold mb-4">Ready to Join Our Mission?</h3>
          <p className="text-blue-100 mb-6 max-w-2xl mx-auto">
            Become part of Canada's leading organization bridging pharmacy and veterinary medicine. Together, we can create healthier communities for people and their beloved animal companions.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button size="lg" className="bg-red-600 hover:bg-red-700 whitespace-nowrap">
              Become a Member
            </Button>
            <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-blue-900 whitespace-nowrap">
              Contact Us
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}